<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4" label="Name" label-align="right" :state="stateForField('name')" :invalid-feedback="errorForField('name')">
              <b-form-input v-model="account.name"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Routing Number" label-align="right" :state="stateForField('routingNumber')" :invalid-feedback="errorForField('routingNumber')">
              <b-form-input v-model="account.routingNumber"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Account Number" label-align="right" :state="stateForField('accountNumber')" :invalid-feedback="errorForField('accountNumber')">
              <b-form-input v-model="account.accountNumber"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Account Type" label-align="right" :state="stateForField('accountType')" :invalid-feedback="errorForField('accountType')">
              <b-dropdown menu-class="dropdown-container" :text="account.accountType"  :variant="hasError('accountType') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="accountType in accountTypes" :key="accountType.id"
                                 @click.prevent="setAccountType(accountType)">{{ accountType.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'PayeeModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editAccount: {
        type: Object,
        required: false
      },

      accountPayee: {
        type: Object,
        required: false
      },

      accountEmployer: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        account: {
          accountType: 'Select Type'
        },
        payee: {
          organizationPayeeId: 0,
          firstName: '',
          lastName: ''
        },
        employer: {
          organizationEmployerId: 0,
          name: ''
        },
        isSaving: false,
        accountTypes: [
          {
            id: 1,
            name: 'Checking'
          },
          {
            id: 2,
            name: 'Savings'
          }
        ]
      }
    },

    watch: {
      editAccount (newValue) {
        this.clearAllErrors()
        this.account = _.clone(newValue)
      },

      accountPayee (newValue) {
        this.clearAllErrors()
        this.payee = _.clone(newValue)
      },

      accountEmployer (newValue) {
        this.clearAllErrors()
        this.payee = {
          organizationPayeeId: 0,
          firstName: '',
          lastName: ''
        }
        this.employer = _.clone(newValue)
      }
    },

    computed: {
      title () {
        if (this.payee && this.account.organizationAccountId) {
          return 'Edit Account'
        }

        return 'Create Account'
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        return !this.hasErrors()
      },

      setAccountType (accountType) {
        this.account.accountType = accountType.name
      },

      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.clearAllErrors()

        this.isSaving = true
        let url = '/Dashboard/Employer/Accounts'
        if (this.payee.organizationPayeeId) {
          url = '/Dashboard/Payee/Accounts'
        }
        api.post(url, this.account).then(response => {
          this.$emit('accountSaved', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to save account: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
